var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"next-button"},[_c('ShadowBox',{staticClass:"shadow-box btn next",attrs:{"opacity":"_60"},on:{"handleClickShadowBox":_vm.handleNextBtnClick}},[_c('i',{staticClass:"far fa-chevron-right"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }